import { render, staticRenderFns } from "./_lottery_code.vue?vue&type=template&id=5dbe7408&scoped=true&"
import script from "./_lottery_code.vue?vue&type=script&lang=js&"
export * from "./_lottery_code.vue?vue&type=script&lang=js&"
import style0 from "./_lottery_code.vue?vue&type=style&index=0&id=5dbe7408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbe7408",
  null
  
)

export default component.exports